<div mat-dialog-content>
    <modal-pqrFormTableNew (closeDialog)="onClose()" [formId]="formId"></modal-pqrFormTableNew>
</div>